<template lang="pug">

  //-
    -
    -
    -
    - DESKTOP
    -
    -
    -
    -

  .container-fluid(v-if="this.$vuetify.breakpoint.smAndUp" class="scaleForDesktop")

    //-
      - RENDERIZA CADA UMA DAS SEMANAS DO MÊS (.sosCalendarWeek)
      -

    .sosCalendarWeek(v-for="(week, weekIndex) in weeks" :key="`table_${weekIndex}`" :class="{ 'sosCalendarWeek--last': weekIndex === weeks.length - 1 }" :id="`week_${week.firstDayOfWeek}`")

      //-
        - [CONDIÇÃO] SEMANA SEM PLANTÕES
        -

      template(v-if="week.showWeek && week.value.some(d => dutiesShifts.some(x => (dutiesByDateTime[`${d.dayFmtYmd}_${x.startTime}`] || []).length > 0)) === false")

        //- RENDERIZA APENAS UMA LINHA CONTENDO OS DIAS DA SEMANA
        .sosCalendarRow
          //- RENDERIZA CADA COLUNA RESPONSÁVEL POR NOMEAR UM DIA DA SEMANA
          .sosCalendarCell.sosCalendarCell--day(v-for="(day, dayIndex) in week.value" :key="`${dayIndex}_${day.dayFmtYmd}`" :class="{ 'sosCalendarCell--day__today': day.isToday, 'sosCalendarCell--day__expired': day.isExpired, 'sosCalendarCell--day__nextMonth': day.day.get('month') !== actualMonth }")
            | {{ day.dayTitle }}

        //- RENDERIZA APENAS UMA LINHA RESPONSÁVEL POR INFORMAR A "AUSÊNCIA DE REGISTRO" EM CADA DIA DA SEMANA
        .sosCalendarRow.sosCalendarRow--time.sosCalendarRow--first.sosCalendarRow--last.sosCalendarRow--empty(data-start-time="")
          //- RENDERIZA COLUNAS (DIAS DA SEMANA)
          .sosCalendarCell(v-for="(day, dayIndex) in week.value" :key="`${day.dayFmtYmd}_0`" :class="{ 'sosCalendarCell--first': dayIndex === 0, 'sosCalendarCell--today': day.isToday, 'sosCalendarCell--expired': day.isExpired, 'sosCalendarCell--noRecord': true, 'sosCalendarCell--nextMonth': day.day.get('month') !== actualMonth }")
            //- RENDERIZA ELEMENTO INTERNO (RESPONSÁVEL POR INFORMAR "AUSÊNCIA DE REGISTRO") EM CADA COLUNA (DIA) PERCORRIDA
            //- .dummyCard
              | Sem registro

      //-
        - [CONDIÇÃO] SEMANA CONTÉM UM OU MAIS PLANTÕES
        -

      template(v-else)

        template(v-if="week.showWeek")

          //- RENDERIZA APENAS UMA LINHA CONTENDO OS DIAS DA SEMANA
          .sosCalendarRow
            //- RENDERIZA CADA COLUNA RESPONSÁVEL POR NOMEAR UM DIA DA SEMANA
            .sosCalendarCell.sosCalendarCell--day(v-for="(day, dayIndex) in week.value" :key="`${dayIndex}_${day.dayFmtYmd}`" :class="{ 'sosCalendarCell--day__today': day.isToday, 'sosCalendarCell--day__expired': day.isExpired, 'sosCalendarCell--day__nextMonth': day.day.get('month') !== actualMonth }")
              | {{ day.dayTitle }}

          //- RENDERIZA LINHAS (HORÁRIOS COM REGISTRO)
          .sosCalendarRow.sosCalendarRow--time(v-for="(dutyShift, dutyShiftIndex) in dutiesShifts.filter(x => week.value.some(d => (dutiesByDateTime[`${d.dayFmtYmd}_${x.startTime}`] || []).length > 0))" :key="`${weekIndex}_${dutyShift.startTime}`" :data-start-time="dutyShift.startTime" :class="{ 'sosCalendarRow--first': dutyShiftIndex === 0, 'sosCalendarRow--last': dutyShiftIndex === dutiesShifts.filter(x => week.value.some(d => (dutiesByDateTime[`${d.dayFmtYmd}_${x.startTime}`] || []).length > 0)).length - 1, 'sosCalendarRow--day': dutyShift.floatStartTime >= 6 && dutyShift.floatStartTime < 18, 'sosCalendarRow--night': (dutyShift.floatStartTime >= 18 && dutyShift.floatStartTime < 24) || (dutyShift.floatStartTime >= 0 && dutyShift.floatStartTime < 6) }")
            //- RENDERIZA COLUNAS (DIAS DA SEMANA)
            .sosCalendarCell(v-for="(day, dayIndex) in week.value" :key="`${day.dayFmtYmd}_${dutyShift.startTime}`" :class="{ 'sosCalendarCell--first': dayIndex === 0, 'sosCalendarCell--today': day.isToday, 'sosCalendarCell--expired': day.isExpired || (day.isToday && dutyShift.floatStartTime < day.floatCurrentTime), 'sosCalendarCell--nextMonth': day.day.get('month') !== actualMonth/* , 'sosCalendarCell--expiredText': (day.isExpired || (day.isToday && dutyShift.floatStartTime < day.floatCurrentTime)) && (dutiesByDateTime[`${day.dayFmtYmd}_${dutyShift.startTime}`] || []).length === 0 */ }")
              //- RENDERIZA PLANTÕES DA LINHA (HORÁRIO) E COLUNA (DIA) PERCORRIDA
              div(v-if="(dutiesByDateTime[`${day.dayFmtYmd}_${dutyShift.startTime}`] || []).length > 0" v-for="(shiftItem, shiftItemKey) in dutiesByDateTime[`${day.dayFmtYmd}_${dutyShift.startTime}`]" :key="`${shiftItemKey}_${shiftItem.plantaoID}`" :class="{ 'shift__margin': dutiesByDateTime[`${day.dayFmtYmd}_${dutyShift.startTime}`].length > 1 && shiftItemKey !== dutiesByDateTime[`${day.dayFmtYmd}_${dutyShift.startTime}`].length - 1 }")
                sos-shift-card(:shift="shiftItem" :showScaleName="showScaleName" :hideProgress="hideProgress" :showValue="showValue" @open="openShift")

  //-
    -
    -
    -
    - MOBILE
    -
    -
    -
    -

  .container-fluid(v-else)

    //- RENDERIZA CADA UMA DAS SEMANAS DO MÊS
    div(v-for="(week, n) in weeks" :key="`week_mobile_${week.firstDayOfWeek}`" :id="`week_mobile_${week.firstDayOfWeek}`")

      //- RENDERIZA CADA DIA DA SEMANA PERCORRIDA ACIMA
      .sosCalendarMobile__day(v-for="(day, dayIndex) in week.value.filter(d => dutiesShifts.some(x => (dutiesByDateTime[`${d.dayFmtYmd}_${x.startTime}`] || []).length > 0))" :key="`mobile_${day.dayFmtYmd}`" :class="{ 'sosCalendarMobile__day--last': dayIndex === week.value.filter(d => dutiesShifts.some(x => (dutiesByDateTime[`${d.dayFmtYmd}_${x.startTime}`] || []).length > 0)).length - 1, 'sosCalendarMobile__day--today': day.isToday, 'sosCalendarMobile__day--expired': day.isExpired, 'sosCalendarMobile__day--nextMonth': day.day.get('month') !== actualMonth }")

        .sosCalendarMobile__dayTitle
          | {{ day.dayTitle }}

        .sosCalendarMobile__dayBody

          //- RENDERIZA CADA HORÁRIO DO DIA PERCORRIDO ACIMA
          .sosCalendarMobile__time(v-for="(dutyShift, dutyShiftIndex) in dutiesShifts.filter(x => (dutiesByDateTime[`${day.dayFmtYmd}_${x.startTime}`] || []).length > 0)" :key="`mobile_${day.dayFmtYmd}_${dutyShift.startTime}`" :class="{ 'sosCalendarMobile__time--last': dutyShiftIndex === dutiesShifts.filter(x => (dutiesByDateTime[`${day.dayFmtYmd}_${x.startTime}`] || []).length > 0).length - 1, 'sosCalendarMobile__time--day': dutyShift.floatStartTime >= 6 && dutyShift.floatStartTime < 18, 'sosCalendarMobile__time--night': (dutyShift.floatStartTime >= 18 && dutyShift.floatStartTime < 24) || (dutyShift.floatStartTime >= 0 && dutyShift.floatStartTime < 6) }")

            .sosCalendarMobile__timeTitle
              | {{ dutyShift.startTime }}

            //- RENDERIZA CADA PLANTÃO DENTRO DO HORÁRIO PERCORRIDO ACIMA
            div(v-for="(shiftItem, shiftItemKey) in dutiesByDateTime[`${day.dayFmtYmd}_${dutyShift.startTime}`]" :key="`${shiftItemKey}_${shiftItem.plantaoID}`" :class="{ 'shift__margin--mobile': dutiesByDateTime[`${day.dayFmtYmd}_${dutyShift.startTime}`].length > 1 && shiftItemKey !== dutiesByDateTime[`${day.dayFmtYmd}_${dutyShift.startTime}`].length - 1 }")
              sos-shift-card(:shift="shiftItem" :showScaleName="showScaleName" :hideProgress="hideProgress" :showValue="showValue" @open="openShift")

</template>

<script>

  import SosShiftCard from '@/components/SosShiftCard'

  export default {
    name: 'SosDutiesCalendar',

    components: {
      'sos-shift-card': SosShiftCard,
    },

    props: {
      hideProgress: { type: Boolean, default: false },
      showValue: { type: Boolean, default: true },
      showScaleName: { type: Boolean, default: () => false },
      actualMonth: { type: Number, required: true },
      weeks: { type: Array, required: true },
      dutiesByDateTime: { type: Object, required: true },
      dutiesShifts: { type: Array, required: true },
    },

    methods: {
      openShift (shift) {
        this.$emit('openShift', shift)
      },
    },
  }

</script>

<style lang="scss" scoped>

  //
  //
  //

  .shift__margin
  {
    margin-bottom: 2px;

    &--mobile {
      margin-bottom: 5px;
    }
  }

  .sosCalendarCell
  {
    position: relative;

    display: table-cell;
    vertical-align: top;

    box-sizing: border-box; /* Para que o padding não afete o tamanho total */

    width: 14.2857142857%;
    padding: 1px;
    border-left: 1px solid rgba(0, 0, 0, 0.01);
    border-right: 1px solid rgba(0, 0, 0, 0.01);
    border-top: 1px solid rgba(0, 0, 0, 0.01);
    background-color: rgba(255, 255, 255, 0.6);

    box-shadow: inset 2px -2px 5px -4px rgba(0, 0, 0, 0.8);
    background-image: linear-gradient(360deg, rgba(0, 0, 0, 0.03), transparent);

    // Opcional: Para garantir que o conteúdo da célula quebre corretamente em múltiplas linhas
    word-wrap: break-word;

    &--day {
      padding-bottom: 7px;
      border-left: 0;
      border-right: 0;
      border-top: 0;
      background-color: transparent;

      box-shadow: none;
      background-image: none;

      color: #333333;
      font-size: 18px;
      font-weight: 700;
      line-height: 18px;
    }

    &--today {
      border-left: 1px solid rgba(0, 0, 255, 0.2);
      border-right: 1px solid rgba(0, 0, 255, 0.2);
      // border-top: 1px solid rgba(0, 0, 255, 0.2);
      background-color: rgba(0, 0, 255, 0.03);

      box-shadow: inset 2px -2px 5px -4px rgba(0, 0, 255, 0.8); // inset 3px -3px 5px -3px rgba(0, 0, 0, 0.1);
      background-image: linear-gradient(360deg, rgba(0, 0, 255, 0.03), transparent);
    }

    &--expired
    {
      background: repeating-linear-gradient(45deg, rgba(255, 255, 255, 1), rgba(220, 220, 220, 0.01) 10px);

      /* &::before
      {
        // z-index: 2;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;

        display: inline-block;
        width: 100%;
        height: 16px; // 24px;
        margin: auto;

        content: 'Expirado';
        color: rgba(0, 0, 0, 0.2);
        font-size: 16px; // 24px;
        line-height: 16px; // 24px;
        text-align: center;

        // font-weight: 400;
        // text-shadow: 1px 1px 7px rgba(255, 255, 255, 0.7);
      } */

      &.sosCalendarCell--today
      {
        background: repeating-linear-gradient(45deg, rgba(0, 0, 255, 0.03), rgba(0, 0, 255, 0.08) 10px);
      }

      /* &.sosCalendarCell--noRecord
      {
        &::before
        {
          color: rgba(0, 0, 0, 0.6); // 0.8
        }
      } */
    }

    &--expiredText
    {
      &::before
      {
        // z-index: 2;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;

        display: inline-block;
        width: 100%;
        height: 16px; // 24px;
        margin: auto;

        content: 'Expirado';
        color: rgba(0, 0, 0, 0.2);
        font-size: 16px; // 24px;
        line-height: 16px; // 24px;
        text-align: center;

        // font-weight: 400;
        // text-shadow: 1px 1px 7px rgba(255, 255, 255, 0.7);
      }

      /* &.sosCalendarCell--today
      {
        background: repeating-linear-gradient(45deg, rgba(0, 0, 255, 0.03), rgba(0, 0, 255, 0.08) 10px);
      } */

      &.sosCalendarCell--noRecord
      {
        &::before
        {
          color: rgba(0, 0, 0, 0.6); // 0.8
        }
      }
    }

    &--nextMonth
    {
      background: repeating-linear-gradient(45deg, rgba(0, 0, 0, 0.01), rgba(220, 220, 220, 0.5) 10px);

      &.sosCalendarCell--noRecord
      {
        &::before
        {
          color: rgba(0, 0, 0, 0.4);
        }
      }
    }

    &--noRecord
    {
      &::before
      {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;

        display: inline-block;
        width: 100%;
        height: 16px;
        margin: auto;

        content: 'Semana vazia';
        // content: 'Semana sem plantão';
        // content: 'Sem registro';
        color: rgba(0, 0, 0, 0.8);
        font-size: 16px;
        line-height: 16px;
        text-align: center;
      }
    }

    &--day__today {
      color: steelblue;
    }

    &--day__expired {
      color: #888888;
    }

    &--day__nextMonth {
      color: darkgray;
    }
  }

  .sosCalendarWeek
  {
    padding-left: 60px;
  }

  .sosCalendarWeek {
    margin-bottom: 20px;
  }

  .sosCalendarWeek__mobile {
    margin-bottom: 50px;
  }

  .sosCalendarWeek,
  .sosCalendarWeek__mobile
  {
    font-size: 0;
    line-height: 1;
    text-align: center;

    &--last {
      margin-bottom: 0;
    }
  }

  .sosCalendarRow
  {
    position: relative;

    display: table;
    width: 100%;
    table-layout: fixed;

    white-space: nowrap;

    &--last
    {
      border-bottom-left-radius: 10px;

      .sosCalendarCell
      {
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);

        &--first {
          border-bottom-left-radius: 0;
        }
      }
    }

    &--first
    {
      border-top-left-radius: 10px;

      .sosCalendarCell
      {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;

        &--first {
          border-top-left-radius: 0;
        }
      }
    }

    &--time
    {
      position: relative;
      min-height: 78px; /* 82px; */ // JESUS: Funciona no firefox?

      &::before
      {
        position: absolute;
        left: -59px;
        // left: -60px;
        top: 0;

        content: attr(data-start-time);

        width: 60px;
        height: 100%;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;

        color: #FFFFFF;
        font-size: 14px;
        line-height: 82px;
        font-weight: 500;
      }
    }

    &--day
    {
      &::before
      {
        box-shadow: inset 3px -3px 5px -3px rgba(0, 0, 0, 0.1);
        background-color: #d2d1d7;

        color: #000000;
      }
    }

    &--night
    {
      &::before
      {
        box-shadow: inset 3px -3px 5px -3px rgba(0, 0, 0, 0.4);
        background-color: #9d9ca3;

        color: #FFFFFF;
        text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.4);
      }
    }

    &--empty
    {
      &::before
      {
        box-shadow: inset 3px -3px 5px -3px rgba(0, 0, 0, 0.4);
        background-color: #9d9ca3;

        background-image: repeating-linear-gradient(45deg, rgba(255, 255, 255, 1), rgba(220, 220, 220, 0.01) 10px);
      }
    }
  }

  //
  //
  //
  // .
  //
  //
  //

  .sosCalendarMobile__dayBody
  {
    padding: 5px;
    border: 1px solid rgba(0, 0, 0, 0.01);
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 0.6);

    background-image: linear-gradient(360deg, rgba(0, 0, 0, 0.03), transparent);

    // Opcional: Para garantir que o conteúdo da célula quebre corretamente em múltiplas linhas
    word-wrap: break-word;
  }

  .sosCalendarMobile__dayTitle
  {
    margin-bottom: 15px;

    color: #333333;
    font-size: 18px;
    font-weight: 700;
    line-height: 18px;
    text-align: center;
  }

  .sosCalendarMobile__day
  {
    margin-bottom: 50px;

    &--last {
      margin-bottom: 0;
    }

    &--today
    {
      .sosCalendarMobile__dayBody {
        border: 1px solid rgba(0, 0, 255, 0.2);
        background-color: rgba(0, 0, 255, 0.03);

        box-shadow: inset 2px -2px 5px -4px rgba(0, 0, 255, 0.8); // inset 3px -3px 5px -3px rgba(0, 0, 0, 0.1);
        background-image: linear-gradient(360deg, rgba(0, 0, 255, 0.03), transparent);
      }

      .sosCalendarMobile__dayTitle {
        color: steelblue;
      }
    }

    &--expired
    {
      .sosCalendarMobile__dayBody {
        background: repeating-linear-gradient(45deg, rgba(255, 255, 255, 1), rgba(220, 220, 220, 0.01) 10px);
      }

      &.sosCalendarMobile__day--today {
        .sosCalendarMobile__dayBody {
          background: repeating-linear-gradient(45deg, rgba(0, 0, 255, 0.03), rgba(0, 0, 255, 0.08) 10px);
        }
      }

      .sosCalendarMobile__dayTitle {
        color: #888888;
      }
    }

    &--nextMonth
    {
      .sosCalendarMobile__dayBody {
        background: repeating-linear-gradient(45deg, rgba(0, 0, 0, 0.01), rgba(220, 220, 220, 0.5) 10px);
      }

      .sosCalendarMobile__dayTitle {
        color: darkgray;
      }
    }
  }

  .sosCalendarMobile__timeTitle
  {
    margin-bottom: 5px;

    padding: 5px;
    border-radius: 10px;

    color: #FFFFFF;
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    text-align: center;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.4);
  }

  .sosCalendarMobile__time
  {
    margin-bottom: 5px;

    &--last {
      margin-bottom: 0;
    }

    &--day
    {
      .sosCalendarMobile__timeTitle
      {
        box-shadow: inset 3px -3px 5px -3px rgba(0, 0, 0, 0.1);
        background-color: #d2d1d7;
      }
    }

    &--night
    {
      .sosCalendarMobile__timeTitle
      {
        box-shadow: inset 3px -3px 5px -3px rgba(0, 0, 0, 0.4);
        background-color: #9d9ca3;
      }
    }
  }

  //
  //
  //
  // DUMMY CARD FOR EMPTY WEEKS
  //
  //
  //

  .dummyCard {
    height: 75px; // Segurança

    color: #333333;
    font-size: 14px;
    font-weight: 500;
    line-height: 75px;
  }

  //
  //
  //
  // RESPONSIVIDADE
  //
  //
  //

  @media (max-width: 1280px)
  {
    .scaleForDesktop
    {
      .sosCalendarWeek
      {
        overflow: auto;

        .sosCalendarRow {
          min-width: 1200px;
        }
      }
    }
  }

</style>
